import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Button, Box, Drawer } from "@mui/material";

import theme from "./theme"; // Import the custom theme

import logoImage from "./assets/kroissant-logo.png"; // Update the path to your logo image
import compraImage from "./assets/compra_24hrs.png";

import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const NavBar: React.FC = () => {
  const handleMenuRedirect = () => {
    window.location.href = "/menu.pdf";
  };

  const handleEncomendaRedirect = () => {
    const message = "Olá, tudo bem? Quero fazer um pedido online...";
    const whatsappUrl = `https://wa.me/558321480945?text=${encodeURIComponent(
      message,
    )}`;
    window.location.href = whatsappUrl;
  };

  const handleDeliveryRedirect = () => {
    const message = "Olá, tudo bem? Quero fazer um pedido online...";
    const whatsappUrl = `https://wa.me/558321480945?text=${encodeURIComponent(
      message,
    )}`;
    window.location.href = whatsappUrl;
  };

  const handleSuporteRedirect = () => {
    window.location.href = "https://wa.me/5583981957808";
  };

  const location = useLocation();
  const firstDomain = window.location.hostname.split(".")[0];
  const secondDomain = window.location.hostname.split(".")[1];
  let trueDomain = "";
  if (firstDomain === "www") {
    trueDomain = secondDomain;
  } else {
    trueDomain = firstDomain;
  }
  const [sideDrawer, setSideDrawer] = useState(false);

  const handleSideDrawer = (bool: boolean) => {
    setSideDrawer(bool);
  };

  // Don't render NavBar for takeaway display page
  if (location.pathname === "/takeaway-bg-display") {
    return null;
  }

  return trueDomain !== "compra" ? (
    <AppBar position="sticky" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ flexDirection: "column", alignItems: "center" }}>
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          <img src={logoImage} alt="Logo" style={{ height: 60 }} />
        </Box>

        {/* Navigation Buttons */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
          <Button color="inherit" component={Link} to="/">
            Inicio
          </Button>
          <Button color="inherit" onClick={handleMenuRedirect}>
            Menu
          </Button>
          <Button color="inherit" component={Link} to="/reserva">
            Reserva
          </Button>
          <Button color="inherit" onClick={handleDeliveryRedirect}>
            Delivery
          </Button>
          <Button color="inherit" onClick={handleEncomendaRedirect}>
            Encomenda
          </Button>
          <Button color="inherit" onClick={handleSuporteRedirect}>
            Suporte
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  ) : (
    <>
      <AppBar
        position="sticky"
        sx={{ zIndex: theme.zIndex.drawer + 1, height: "10vh" }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Button onClick={() => handleSideDrawer(!sideDrawer)}>
            <MenuOpenIcon />
          </Button>
          <Box>
            <img
              src={compraImage}
              alt="Compra 24hrs"
              style={{ height: "8vh", marginTop: "2vh" }}
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer open={sideDrawer} onClose={() => handleSideDrawer(false)}>
        <Box
          role="presentation"
          onClick={() => handleSideDrawer(false)}
          sx={{
            width: "100vw",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Button
              variant="contained"
              color="inherit"
              sx={{ fontSize: "1.25rem", marginBottom: "1rem", width: "80%" }}
              component={Link}
              to="/"
              startIcon={<CheckBoxIcon />}
            >
              Lista Compra
            </Button>
            <Button
              variant="contained"
              color="inherit"
              sx={{ fontSize: "1.25rem", marginBottom: "1rem", width: "80%" }}
              startIcon={<ListAltIcon />}
              component={Link}
              to="/pedido"
            >
              Pedido Compra
            </Button>
            <Button
              variant="contained"
              color="inherit"
              sx={{ fontSize: "1.25rem", marginBottom: "1rem", width: "80%" }}
              startIcon={<AutoStoriesIcon />}
              component={Link}
              to="/biblioteca"
            >
              BiBlioteca
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default NavBar;
